import RouterLink, { LinkProps as RouterLinkProps } from 'next/link'
import { useRouter } from 'next/router'
import React from 'react'

import cn from 'classnames'

import { Link, LinkProps } from '@material-ui/core'

import useNavLinkStyles from './NavLink.styles'

type AllProps = LinkProps & RouterLinkProps

const Navlink: React.FC<AllProps> = ({ href, as, children, ...props }) => {
  const s = useNavLinkStyles()
  const router = useRouter()

  return (
    <RouterLink href={href} as={as}>
      <Link
        underline="hover"
        color="textPrimary"
        // eslint-disable-next-line security/detect-non-literal-fs-filename
        className={cn(s.link, {
          active: router.pathname === href
        })}
        {...props}
      >
        {children}
      </Link>
    </RouterLink>
  )
}

export default Navlink
